import { useGetDashPinnedList } from '@apps-common/apis/portal/dash/get-dash-pinned-list'
import { DashNoResultsCard } from '@apps-common/apps/portal/pages/dashboard/components/DashNoResultsCard'
import { UnitListCardSmSkeleton } from '@apps-common/apps/portal/pages/units/components'
import { UnitListCardSm } from '@apps-common/apps/portal/pages/units/components/UnitListCardSm'
import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { commonIcons } from '@apps-common/config/icons'
import { UNIT_STATUS_ACTIVE } from '@apps-common/config/unit-filter'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS, usePortalUnitsFilterStore } from '@apps-common/stores'
import {
  DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
  useManagementUnitsFilterStore
} from '@apps-common/stores/useManagementUnitsFilterStore'
import { ROUTE_UNITS } from '@apps-radionet-portal/config/private-routes'

export const PinnedUnitsCard = () => {
  const { navigateRoot } = useNavigation()
  const { setTempState: setPortalTempState } = usePortalUnitsFilterStore()
  const { setTempState: setManagementTempState } = useManagementUnitsFilterStore()
  const { isLoading, isError, data } = useGetDashPinnedList({})

  const loading = isLoading || isError || !data

  return (
    <div className='relative bg-surface-2 w-full h-[100%] sm:rounded-3xl overflow-hidden scrollbar-none border-[1px] border-border'>
      <div className='absolute z-[55] top-0 left-0 pt-4 px-6 sm:pt-7 sm:px-7 pb-[10px] w-full sm:rounded-t-3xl backdrop-blur'>
        <div className='flex items-center justify-between'>
          <PageSubtitle>Pinned devices</PageSubtitle>
          <Authorization
            roles={AUTH_CLAIMS.managementAdmin.roles}
            scopes={AUTH_CLAIMS.managementAdmin.scopes}
            notAuthorizedFallback={
              <ButtonRoundArrow
                disabled={loading}
                classes='bg-brand'
                iconClasses='text-on-brand'
                callback={() => {
                  setPortalTempState({
                    ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
                    status: UNIT_STATUS_ACTIVE.value as string,
                    pinnedUnits: true
                  })
                  navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
                }}
                tooltip={{
                  id: `dashboard-pinned-view-all-portal-tooltip`,
                  message: 'View all'
                }}
              />
            }
          >
            <ButtonRoundArrow
              disabled={loading}
              classes='bg-brand'
              iconClasses='text-on-brand'
              callback={() => {
                setManagementTempState({
                  ...DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
                  status: UNIT_STATUS_ACTIVE.value as string,
                  pinnedUnits: true
                })
                navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
              }}
              tooltip={{
                id: `dashboard-pinned-view-all-management-tooltip`,
                message: 'View all'
              }}
            />
          </Authorization>
        </div>
      </div>
      <div className='relative z-[1] flex items-center justify-start flex-nowrap overflow-x-auto overflow-y-scroll h-full sm:grid sm:grid-cols-2 gap-[15px] !pt-[70px] sm:!pt-[85px] pl-5 sm:p-7 scrollbar-none'>
        {!loading && data?.length === 0 && <DashNoResultsCard Icon={commonIcons.unPinUnit}>You have no pinned devices.</DashNoResultsCard>}
        {loading &&
          Array.from(Array(4).keys()).map((k, i) => (
            <UnitListCardSmSkeleton
              key={`pinned-unit-skeleton-${k}`}
              index={i}
              bgClasses='bg-skeleton min-w-[200px] sm:min-w-[185px] border border-skeleton-border'
              textClasses=''
              iconClasses=''
              bgSecondaryClasses='bg-skeleton-hi'
              textSecondaryClasses=''
              bgTertiaryClasses='bg-skeleton-hi'
            />
          ))}
        {!loading &&
          data?.map((d, i) => (
            <UnitListCardSm
              key={`pinned-unit-${d.unitId}-${i}`}
              bgClasses='bg-surface min-w-[200px] sm:min-w-[185px] border border-border'
              textClasses='text-text'
              iconClasses='text-text-muted'
              bgSecondaryClasses='bg-surface-2'
              textSecondaryClasses='text-text-muted'
              bgTertiaryClasses='bg-surface'
              unit={{ ...d, status: UNIT_STATUS_ACTIVE.value as string }}
            />
          ))}
        <div className='w-3 shrink-0 sm:hidden' />
      </div>
    </div>
  )
}
